<template>
  <div id="app">
        <nav class="navbar navbar-expand-lg navbar-dark navbar-custom fixed-top">
            <div class="container">
                <a class="navbar-brand" href="#inicio">
                    <img src="/img/logo.png" alt="Logo" />
                </a>
                <div class="d-flex align-items-center d-lg-none social-icons">
                    <a href="https://www.facebook.com/OuvidoriaGeralDPMT" class="me-2" aria-label="Facebook"><i class="bi bi-facebook"></i></a>
                    <a href="https://www.instagram.com/ouvidoriageraldpmt/" class="me-2" aria-label="Instagram"><i class="bi bi-instagram"></i></a>
                    <a href="#" aria-label="YouTube"><i class="bi bi-youtube"></i></a>
                </div>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-label="Abrir menu">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarNav">
                    <ul class="navbar-nav ms-auto">
                        <li class="nav-item"><a class="nav-link" href="#inicio">Início</a></li>
                        <li class="nav-item"><a class="nav-link" href="#ouvidoria_externa">Quem Somos</a></li>
                        <li class="nav-item"><a class="nav-link" href="#estrutura">Estrutura</a></li>
                        <li class="nav-item"><a class="nav-link" href="#equipe">Equipe</a></li>
                        <li class="nav-item"><a class="nav-link" href="#documentos">Documentos</a></li>
                        <li class="nav-item"><a class="nav-link" href="#fale">Fale Conosco</a></li>
                    </ul>
                    <div class="d-none d-lg-flex align-items-center social-icons ms-3">
                            <a href="https://www.facebook.com/OuvidoriaGeralDPMT" aria-label="Facebook"><i class="bi bi-facebook"></i></a>
                            <a href="https://www.instagram.com/ouvidoriageraldpmt/" aria-label="Instagram"><i class="bi bi-instagram"></i></a>
                            <a href="#" aria-label="YouTube"><i class="bi bi-youtube"></i></a>
                    </div>
                </div>
            </div>
        </nav>


        
        <!-- Hero Section -->
        <section class="hero-section d-flex align-items-center">
            <div class="container text-white text-center">
                <div class="hero-text">
                    <h1 class="fw-bold">Conheça a Ouvidoria da DPE/MT</h1>
                    <p>A Ouvidoria Geral é um órgão auxiliar da Defensoria Pública do Estado, de promoção da qualidade dos serviços prestados pela Instituição.</p>
                    <a href="#ouvidoria_externa" class="btn btn-success">Conheça</a>
                </div>
            </div>
        </section>

        <!-- SIOUV Section -->
        <section class="siouv-section">
            <div class="container">
                <div class="row align-items-center">
                        <div class="col-lg-6 text-center mb-4 mb-lg-0">
                            <img src="/img/siouv-logo.png" alt="Logo Siouv" class="img-fluid">
                        </div>
                        <div class="col-lg-6 text-center text-lg-start">
                            <h2>Acesse o Sistema SIOUV</h2>
                            <p>Utilize o botão abaixo para se cadastrar ou caso já possua cadastro utilize o botão entrar, para consultar sua manifestação.</p>
                            <div class="d-flex justify-content-center justify-content-lg-start gap-3">
                                <button class="btn btn-success" @click="Identificar">
                                    <i class="bi bi-box-arrow-in-right"></i> Entrar
                                </button>
                                <button class="btn btn-outline-success" @click="Cadastrar">
                                    <i class="bi bi-person-plus"></i> Cadastrar
                                </button>    
                            </div>
                        </div>
                </div>
            </div>
        </section>

      <!-- Tipos de Manifestação Section -->
      <section class="py-5" style="background-color: #eaf6f2;" id="manifestacoes" ref="manifestacoes">
        <div class="container text-center">
          <h2 class="fw-bold mb-5 text-success">Qual tipo de manifestação você deseja fazer?</h2>
          <div class="row row-cols-1 row-cols-md-3 g-4 justify-content-center">
            <div class="col" v-for="(opcao, index) in opcoes" :key="index">
              <div class="card h-100 shadow-sm border-0">
                <div class="card-body">
                  <div class="icon-circle bg-opacity-25 mb-3 mx-auto"
                      :class="{ 
                        'bg-danger': index === 0, 
                        'bg-primary': index === 1, 
                        'bg-warning': index === 2, 
                        'bg-success': index === 3, 
                        'bg-info': index === 4, 
                        'bg-secondary': index === 5
                      }">
                    <i class="bi fs-4" 
                      :class="{
                        'bi-chat-left-text text-danger': index === 0,
                        'bi-lightbulb text-primary': index === 1,
                        'bi-exclamation-triangle text-warning': index === 2,
                        'bi-award text-success': index === 3,
                        'bi-file-text text-info': index === 4,
                        'bi-shield text-secondary': index === 5
                      }"></i>
                  </div>
                  <h5 class="fw-bold">{{ opcao.titulo }}</h5>
                  <b-button 
                      v-b-modal="'modal-manifestacao-' + index"
                      :variant="index === 0 ? 'danger' : 
                                index === 1 ? 'primary' :
                                index === 2 ? 'warning' :
                                index === 3 ? 'success' :
                                index === 4 ? 'info' : 'secondary'"
                    >
                      Acessar
                  </b-button>
                  
                  <!-- Modal para cada tipo de manifestação -->
                  <b-modal 
                    :id="'modal-manifestacao-' + index" 
                    :title="opcao.titulo"
                    hide-footer
                    centered
                    :header-bg-variant="index === 0 ? 'danger' : 
                                      index === 1 ? 'primary' : 
                                      index === 2 ? 'warning' : 
                                      index === 3 ? 'success' : 
                                      index === 4 ? 'info' : 'secondary'"
                    header-text-variant="white"
                  >
                    <div v-html="opcao.texto" style="text-align: justify;"></div>
                    <div class="d-flex justify-content-end mt-3">
                      <b-button 
                        variant="secondary" 
                        class="me-2" 
                        @click="$bvModal.hide('modal-manifestacao-' + index)"
                      >
                        Fechar
                      </b-button>
                      <b-button 
                        @click="AbrirManifestacao(index); $bvModal.hide('modal-manifestacao-' + index)"
                        :variant="index === 0 ? 'danger' : 
                                index === 1 ? 'primary' : 
                                index === 2 ? 'warning' : 
                                index === 3 ? 'success' : 
                                index === 4 ? 'info' : 'secondary'"
                      >
                        Manifestar-se
                      </b-button>
                    </div>
                  </b-modal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

     <!-- Notícias Section -->
      <section class="py-5" id="noticias">
        <div class="container">
          <h2 class="fw-bold text-center text-success mb-5">Notícias</h2>
          <div class="row g-4">
            <!-- Loader para notícias -->
            <template v-if="carregando_noticias">
              <div v-for="i in 6" :key="i" class="col-md-6 col-lg-4">
                <div class="card border-0 shadow-sm h-100">
                  <div class="card-body">
                    <vue-skeleton-loader :width="93" :height="25" class="mb-2" />
                    <vue-skeleton-loader :width="100" :height="20" />
                    <vue-skeleton-loader :width="100" :height="20" />
                  </div>
                </div>
              </div>
            </template>
            
            <!-- Notícias carregadas -->
            <div v-for="noticia in noticias" :key="noticia.intnoticiaid" class="col-md-6 col-lg-4">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body">
                  <span class="badge bg-success mb-2">
                    <b-icon-calendar-event class="me-1"></b-icon-calendar-event> {{ noticia.data }}
                  </span>
                  <h6 class="fw-bold">{{ noticia.strtitulo }}</h6>
                  <a :href="UrlNoticia + noticia.intnoticiaid" target="_blank" class="text-success text-decoration-none">
                    Leia mais
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

            <!-- Ouvidoria Externa Section -->
        <section class="py-5" style="background-color: #eaf6f2;" id="ouvidoria_externa">
            <div class="container">
            <div class="bg-white p-4 p-md-5 rounded shadow-sm">
                <h2 class="fw-bold text-center text-success mb-4">A Ouvidoria Externa</h2>
                <p class="mb-4">
                A Ouvidoria geral é órgão auxiliar da Defensoria Pública do Estado, de promoção da qualidade dos serviços prestados pela Defensoria Pública (Lei Complementar 80/94, com alterações promovidas pela Lei Complementar 132/2009). Criada pela Lei Complementar nº 146, de 29 de maio de 2012 em Mato Grosso, tem como competência a participação popular, sendo canal de manifestações populares, sejam elas no modelo de sugestões, elogios, denúncias, reclamações e solicitações de informações.
                </p>
                <div class="row g-4">
                <div class="col-md-4">
                    <div class="bg-custom p-4 rounded h-100 ouvidoria-box">
                    <h5 class="fw-bold text-success">Missão</h5>
                    <p class="mb-0">
                        Ser o canal que conecta a população Mato-grossense e a Defensoria Pública, assegurando que as vozes dos cidadãos sejam ouvidas e transformadas em ações, promovendo a defesa dos direitos humanos, a inclusão social e a cidadania, fortalecendo a Defensoria Pública em sua missão de garantir o acesso à justiça e os direitos humanos.
                    </p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="bg-custom p-4 rounded h-100 ouvidoria-box">
                    <h5 class="fw-bold text-success">Função</h5>
                    <p class="mb-0">
                        Atuar como ponte entre a sociedade civil e o controle social, atuar como mediadora de conflitos, receber manifestações, sugestões, reclamações, denúncias, elogios e pedidos de informações sobre o funcionamento da Defensoria Pública, fomentar o diálogo e propor melhorias, fortalecendo a transparência e a gestão democrática.
                    </p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="bg-custom p-4 rounded h-100 ouvidoria-box">
                    <h5 class="fw-bold text-success">Quem deve procurar a Ouvidoria?</h5>
                    <p class="mb-0">
                        Na Ouvidoria da Defensoria Pública de Mato Grosso, todos têm voz: Cidadãos, assistidos (as), servidores (as), defensores (as), estagiários (as), colaboradores (as) e qualquer pessoa que precise de atendimento ou se encontre em situação de vulnerabilidade. Estamos aqui para acolher, ouvir, registrar suas demandas e transformar o diálogo em ações. Justiça começa ouvindo você!
                    </p>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </section>

        <!-- Estrutura Section -->
        <section class="py-5 estrutura-section" id="estrutura" >
            <div class="container" style="max-width: 960px;">
            <h2 class="fw-bold text-center text-success mb-5">Estrutura</h2>
            <div class="row align-items-start">
                <div class="col-md-5 mb-4 mb-md-0">
                <img src="/img/responsavel-ouvidoria.png" alt="Foto do Ouvidor" class="img-fluid rounded shadow ouvidor-img">
                </div>
                <div class="col-md-7 d-flex flex-column justify-content-start">
                <h5 class="fw-bold text-success mb-2">Getúlio Pedroso da Costa Ribeiro</h5>
                <p class="mb-2">
                    Graduado em Direito pelo Centro Universitário Belo-Americano de São Paulo/SP, iniciou sua trajetória na advocacia popular em 2014. Reconhecido por seu compromisso com a justiça social, direitos humanos e defesa das minorias, ingressou na Defensoria Pública do Estado de Mato Grosso (DPE/MT) para o período de 2020/2024 e reeleito para mandato 2025/2028.
                </p>
                <p class="mb-0">
                    Atualmente, também integra o Conselho Nacional de Ouvidorias de Defensorias Públicas do Brasil (CNODP) atuando como Diretor Jurídico, reforçando sua dedicação e liderança no Cenário Nacional. O Ouvidor-geral é o chefe da Ouvidoria-geral, escolhido pelo Conselho Superior da Defensoria Pública do Estado, não integrante da carreira, indicado em lista tríplice formada pela sociedade civil, para mandato de dois anos, podendo ser reconduzido uma única vez.
                </p>
                </div>
            </div>
            </div>
        </section>

        <!-- Equipe Section -->
        <section class="py-5 text-center" style="background-color: #eaf6f2;" id="equipe">
            <div class="container" style="max-width: 960px;">
            <h2 class="fw-bold text-success mb-4">Equipe</h2>
            <div class="bg-white p-4 rounded shadow">
                <ul class="list-unstyled mb-0">
                <li class="mb-1">Getúlio Pedroso da Costa Ribeiro</li>
                <li class="mb-2"><strong>Ouvidor-geral da DPE/MT</strong></li>
                <li class="mb-1">Paulo Arthur Gomes Gontijo</li>
                <li class="mb-2"><strong>Assessor Técnico</strong></li>
                <li class="mb-1">Patricia Celes Rodrigues</li>
                <li class="mb-2"><strong>Assessora Técnica</strong></li>
                <li class="mb-1">Ildmar Botelho da Costa Campos</li>
                <li class="mb-2"><strong>Técnico Administrativo Área Fim</strong></li>
                <li class="mb-1">Milena Santos e Silva</li>
                <li class="mb-2"><strong>Estagiária de Pós-Graduação</strong></li>
                </ul>
            </div>
            </div>
        </section>
        
  
        <!-- Gestões Anteriores Section -->
        <section class="py-5 text-center">
            <div class="container" style="max-width: 960px;">
            <h2 class="fw-bold text-success mb-4">Gestões Anteriores</h2>
            <div class="bg-white p-4 rounded shadow">
                <ul class="equipe list-unstyled mb-0">
                <li class="mb-4">
                    <h6 class="fw-bold text-success mb-1">Getúlio Pedroso da Costa Ribeiro</h6>
                    <p class="mb-0"><i class="bi bi-clock me-2"></i>2020 - 2024</p>
                </li>
                <hr class="border-black">
                <li class="mb-4">
                    <h6 class="fw-bold text-success mb-1">Cristiano Nogueira Peres Preza</h6>
                    <p class="mb-0"><i class="bi bi-clock me-2"></i>2020 e 2015 - 2022</p>
                </li>
                <hr class="border-black">
                <li class="mb-4">
                    <h6 class="fw-bold text-success mb-1">Lúcio Andrade Hilário do Nascimento</h6>
                    <p class="mb-0"><i class="bi bi-clock me-2"></i>2015 - 2016 e 2017 - 2018</p>
                </li>
                <hr class="border-black">
                <li>
                    <h6 class="fw-bold text-success mb-1">Paulo Rogério Lemos Melo de Menezes</h6>
                    <p class="mb-0"><i class="bi bi-clock me-2"></i>2011 - 2012 e 2013 - 2014</p>
                </li>
                </ul>
            </div>
            </div>
        </section>
        
        <!-- Documentos da Ouvidoria Section -->
        <section class="py-5" style="background-color: #eaf6f2;" id="documentos" ref="documentos">
          <div class="container" style="max-width: 1080px;">
            <h2 class="fw-bold text-center text-success mb-5">Documentos da Ouvidoria</h2>
            
            <!-- Loader para documentos -->
            <template v-if="carregando_documentos">
              <div class="row g-4">
                <div class="col-md-4" v-for="i in 6" :key="i">
                  <div class="bg-white text-center p-4 rounded shadow-sm">
                    <vue-skeleton-loader :width="100" :height="91" />
                  </div>
                </div>
              </div>
            </template>
            
            <!-- Documentos carregados -->
            <div class="row g-4" v-else>
              <div class="col-md-4" v-for="documento in documentos" :key="documento.idconteudosite">
                <div class="bg-white text-center p-4 rounded shadow-sm">
                  <i class="bi bi-download fs-2 text-success"></i>
                  <p class="mb-1"><strong>{{ documento.strnomeconteudo }}</strong></p>
                  <a :href="urlDoc + documento.strarquivo" target="_blank">
                    <b-button class="btn btn-documento text-white">Download</b-button>
                  </a>
                </div>
              </div>
            </div>
            
            <div class="text-center mt-4">
              <a href="#" @click.prevent="pegarDocumentos" v-if="mais_documentos && !carregando_documentos" class="text-success text-decoration-none">Carregar mais...</a>
            </div>
          </div>
        </section>


        <!-- Footer -->
        <footer class="py-5 text-white" style="background-color: #065f46;" id="fale">
            <div class="container">
            <div class="row text-start">
                <div class="col-md-3 mb-4">
                <h6><i class="bi bi-person me-2"></i>Quem Somos?</h6>
                <p class="small">A Ouvidoria Geral da Defensoria Pública de MT conecta você diretamente à instituição, recebendo manifestações para melhorar os serviços e fortalecer o cidadão.</p>
                </div>
                <div class="col-md-3 mb-4">
                <h6><i class="bi bi-geo-alt me-2"></i>Endereço</h6>
                <p class="small">Edifício Pantanal Business, Av. do CPA - Prof. Historiador Rubens de Mendonça, nº 2.982, Jardim Aclimação - 1º Andar - Sala 15<br>CEP 78050-970 - Cuiabá - MT</p>
                </div>
                <div class="col-md-3 mb-4">
                <h6><i class="bi bi-clock me-2"></i>Horário de Atendimento</h6>
                <p class="small">Segunda a Sexta-Feira, das 8h às 18h</p>
                </div>
                <div class="col-md-3 mb-4">
                <h6><i class="bi bi-telephone me-2"></i>Contatos</h6>
                <ul class="list-unstyled small">
                    <li><a href="https://wa.me/5565999454318" class="text-white text-decoration-none">Contato: (65) 99945-4318</a></li>
                    <li><a href="https://wa.me/5565999789072" class="text-white text-decoration-none">Contato: (65) 99978-9072</a></li>
                    <li><a href="https://wa.me/5565999050123" class="text-white text-decoration-none">Contato: (65) 99905-0123</a></li>
                    <li><a href="https://wa.me/5565999634414" class="text-white text-decoration-none">Contato: (65) 99963-4414</a></li>
                    <li><a href="https://wa.me/5565999654454" class="text-white text-decoration-none">ChatBot (65) 99965-4454 Opção 143</a></li>
                    <li><a href="mailto:ouvidoria@dp.mt.gov.br" class="text-white text-decoration-none">ouvidoria@dp.mt.gov.br</a></li>
                </ul>
                </div>
            </div>
            <hr class="border-light">
            <div class="d-flex justify-content-center align-items-center gap-4 mb-3">
                <img src="/img/logo.png" alt="Logo Defensoria" class="img-fluid" style="max-height: 150px;">
            </div>
            <div class="text-center small">© Copyright | {{ ano }} | Defensoria da Defensoria Pública do Estado de Mato Grosso</div>
            </div>
        </footer>  
      
   

        <ModalIdentificacao />
        <ModalRedefinirSenha :token="this.token" />
        <ModalCadastrar />
        <ModalManifestacao :titulo="manifestacaoAtual.titulo" :cor="manifestacaoAtual.cor" :inttipomanifestacaoid="manifestacaoAtual.tipo" />
 



  </div>
  
</template>



<script>
import ModalIdentificacao from "./components/ModalIdentificacao.vue";
import ModalRedefinirSenha from "./components/ModalRedefinirSenha.vue";
import ModalCadastrar from "./components/ModalCadastrar.vue";
import ModalManifestacao from "./components/ModalManifestacao.vue";
import VueSkeletonLoader from "skeleton-loader-vue";
export default {
  name: "App",
  components: {
    ModalIdentificacao,
    ModalRedefinirSenha,
    ModalCadastrar,
    ModalManifestacao,
    VueSkeletonLoader,
  },
  data() {
    return {
      carregando_noticias: true,
      carregando_documentos: true,
      mais_documentos: true,
      pagina_documentos: 0,
      modalIdentificar: 1000,
      modalManifestacao: 8000,
      manifestacaoAtual: { titulo: "", cor: "#198754", tipo: 1 },
      modalCadastrar: 7000,
      modalRedefinir: 9000,
      ano: new Date().getFullYear(),
      api: "https://ouvidoria.defensoria.mt.def.br/api/v1/",
      urlDoc: "https://defensoria.mt.def.br",
      UrlNoticia: "https://defensoria.mt.def.br/dpmt/noticias/",
      noticias: [],
      documentos: [],
      token: null,
      opcoes: [
        {
          titulo: "Reclamações",
          texto:
            "Manifestação de insatisfação com o serviço público prestado pela Defensoria Pública, incluindo ação e omissão da sua administração e/ou dos seus defensores públicos, servidores e estagiários. Também incluem-se nessa categoria as críticas e opiniões desfavoráveis sobre os serviços e atos da Defensoria Pública do Estado e os seus respectivos membros.<br><a href='#none' onClick='Identificar()'>Manifestar-se</a>",
        },
        {
          titulo: "Sugestões",
          texto:
            "Apresentação de ideia ou formulação de proposta de aprimoramento de políticas e serviços prestados pela Defensoria Pública.<br><a href='#none' onClick='Identificar()'>Manifestar-se</a>",
        },
        {
          titulo: "Denúncias",
          texto:
            "Comunicação de prática de irregularidade ou ato ilícito cuja solução dependa da atuação de órgão de controle interno ou externo. Devem envolver irregularidades ocorridas na Defensoria Pública, como crimes, infrações disciplinares, atos improbidade administrativa, de corrupção, exercício negligente ou abusivo dos cargos, emprego e funções.<br><a href='#none' onClick='Identificar()'>Manifestar-se</a>",
        },
        {
          titulo: "Elogios",
          texto:
            "Demonstração de apreço, reconhecimento ou satisfação sobre o serviço oferecido e/ou recebido ou relativo às pessoas que participaram do serviço/atendimento.<br><a href='#none' onClick='Identificar()'>Manifestar-se</a>",
        },
        {
          titulo: "Solicitações",
          texto:
            "Requerimentos que solicitam uma providência prática, pedidos de informações, esclarecimentos, orientações e simplificações.<br><a href='#none' onClick='Identificar()'>Manifestar-se</a>",
        },
        {
          titulo: "Comunicação anônima",
          texto:
            "São informações de origem anônima que comunicam irregularidades com indícios mínimos de relevância, autoria e materialidade, nos termos da Lei 13.608/2018, as quais, por não serem identificadas, não ensejam obrigação de resposta conclusiva.<br><a href='#none' onClick='Identificar()'>Manifestar-se</a>",
        },
      ],
    };
  },
  methods: {

    alertaSucesso(mensagem) {
      this.$swal("Confirmação", mensagem, "success");
    },
    alertaErro(mensagem) {
      this.$swal("Erro", mensagem, "error");
      //this.Toast.fire(mensagem, "", "error");
    },
    Identificar() {
      this.modalIdentificar++;
      this.$root.$emit("bv::show::modal", "modal-login");
    },
    AbrirManifestacao(index) {
      const cores = ["#dc3545", "#0d6efd", "#ffc107", "#198754", "#0dcaf0", "#6c757d"];
      const tipos = [1, 2, 3, 4, 5, 6];
      this.manifestacaoAtual = {
        titulo: this.opcoes[index].titulo,
        cor: cores[index],
        tipo: tipos[index],
      };
      this.modalManifestacao++;
      this.$root.$emit("bv::show::modal", "modal-manifestacao-form");
    },
    Cadastrar() {
      this.modalCadastrar++;
      this.$root.$emit("bv::show::modal", "modal-cadastrar");
    },
    Redefinir() {
      this.modalRedefinir++;
      this.$root.$emit("bv::show::modal", "modal-redefinir");
    },
    Deslizar(documento) {
      this.$smoothScroll({
        scrollTo: document.getElementById(documento),
        hash: "#" + documento,
      });
    },
    DeslizarMovel(documento) {
      let el = "";
      switch (documento) {
        case "quemsomos":
          el = this.$refs.quemsomos;
          break;
        case "estrutura":
          el = this.$refs.estrutura;
          break;
        case "documentos":
          el = this.$refs.documentos;
          break;
        case "manifestese":
          el = this.$refs.manifestese;
          break;
        default:
          el = this.$refs.inicio;
      }
      var top = el.offsetTop;
      window.scrollTo(0, top - 90);
      if (this.$mq === "xs" || this.$mq === "sm")
        this.$root.$emit("bv::toggle::collapse", "sidebar-menu");
    },
    async pegarNoticias() {
      await this.axios.get(this.api + "noticias").then((response) => {
        this.carregando_noticias = false;
        this.noticias = response.data;
      });
    },
    async pegarDocumentos() {
      this.carregando_documentos = true;

      await this.axios
        .get(this.api + "documentos?page=" + this.pagina_documentos)
        .then((response) => {
          this.pagina_documentos++;
          this.carregando_documentos = false;
          if (response.data.data.length < 6) this.mais_documentos = false;
          this.documentos = this.documentos.concat(response.data.data);
        });
    },
    TratarUrl() {
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      if (params.get("ativacao") !== null) {
        this.HabilitarConta(params.get("ativacao"));
      }
      if (params.get("recuperar") !== null) {
        this.token = params.get("recuperar");
        this.Redefinir();
      }
      if (params.get("login") !== null) {
        this.Identificar();
      }
    },
    HabilitarConta(token) {
      this.$swal.fire({
        title: "Ativação de conta",
        html: "Estamos ativando a sua conta, aguarde...",
        didOpen: () => {
          this.$swal.showLoading();
          this.axios
            .get(this.api + "usuario/habilitar/" + token)
            .then((response) => {
              if (response.data) {
                this.$swal
                  .fire({
                    title: "Tudo certo",
                    text: response.data.mensagem,
                    icon: "success",
                    confirmButtonColor: "green",
                  })
                  .then(() => {
                    this.Identificar();
                  });
              }
            })
            .catch(() => {
              this.$swal.fire({
                title: "Erro",
                text: "O token de ativação é inválido!",
                icon: "error",
                showConfirmButton: false,
                showDenyButton: true,
                denyButtonText: "Ok",
              });
            });
        },
      });
    },
    RecuperarSenha() {},
  },
  mounted: function () {
    this.pegarNoticias();
    this.pegarDocumentos();
    this.TratarUrl();
  },
  created() {
    window.Identificar = this.Identificar.bind(this);
  },
};
</script>

<style>

* {
  box-sizing: border-box;
}

html {
    scroll-padding-top: 100px; /* ajuste conforme a altura da navbar */
}
body {
  padding-top: 90px !important;
} 


html, body {
    width: 100%;
    overflow-x: hidden;
}
section, .container, .row {
  overflow-x: hidden;
}
.hero-section {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), 
              url('/img/background.png') no-repeat center center;
  background-size: cover;
  color: white;
  padding: 160px 0;
}
.hero-text {
  background-color: rgba(255, 255, 255, 0.1);
  padding: 50px;
  border-radius: 15px;
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
  transition: all 0.3s ease-in-out;
}
.hero-text h1 {
  font-size: 2.5rem;
}
.hero-text p {
  font-size: 1.2rem;
}
.hero-text:hover {
  background-color: rgba(255, 255, 255, 0.15);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
  transform: none; /* se quiser remover o scale */
}
.siouv-section {
  padding: 60px 0;
}
.siouv-section img {
  max-width: 250px;
  transition: transform 0.4s ease-in-out;
}
.siouv-section img:hover {
  /* transform: scale(1.05); */
}
.siouv-section .btn {
  /* transition: transform 0.2s ease-in-out; */
  transition: all 0.2s ease-in-out;
}
.siouv-section .btn:hover {
  /* transform: scale(1.05); */
  transform: none; /* remove o scale */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}
.social-icons {
  background-color: transparent !important;
}
.social-icons a {
  color: #ffffff;
  font-size: 1.3rem;
  margin-left: 15px;
  transition: color 0.3s;
}
.social-icons a:hover {
  color: #d1e7dd;
}

.ouvidor-img {
    max-height: 420px;
    object-fit: cover;
    width: 100%;
}

.navbar-brand img {
    height: 90px;
    max-width: 100%;
   
}

/* Menu nav custom */
.navbar-nav .nav-link {
    font-size: 1.1rem;
    padding: 0.5rem 1rem;
    position: relative;
    transition: color 0.3s ease;
    color: #ffffff !important; /* ou outra cor base */
}

.navbar-nav .nav-link::after {
    content: '';
    position: absolute;
    bottom: 0.3rem;
    left: 0;
    width: 0%;
    height: 2px;
    background-color: #1fe281;
    transition: width 0.3s ease-in-out;
}

.navbar-nav .nav-link:hover::after,
.navbar-nav .nav-link.active::after {
    width: 100%;
}

.navbar-nav .nav-link:hover,
.navbar-nav .nav-link.active {
    color: #d1e7dd;
}

.navbar-custom {
    background-color: #235f46; /* exemplo de tom de verde escuro */
   
}
.estrutura-section p {
    text-align: justify;
}
 /* Justificar texto da ouvidoria externa */
#ouvidoria_externa p {
    text-align: justify;
}


.bg-custom {
    background-color: #f5f9f7 !important;
}
.icon-circle {
    width: 64px;
    height: 64px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.3s ease;
  }
  .icon-circle:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .btn-documento {
    color: white !important;
    background-color: #40B392FF !important;
    border-color: #239273FF !important;
    transition: all 0.3s ease;
  }

  .btn-documento:hover {
    background-color: #054e3b !important;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  }

  .modal-header .close {
    background-color: #dc3545 !important; /* Vermelho Bootstrap */
    border-radius: 4px;
    color: white !important;
    opacity: 1 !important;
    padding: 0.25rem 0.5rem;
    line-height: 1;
  }

  .modal-header .close:hover {
    background-color: #c82333;
  }

</style>